import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonsealService } from 'src/app/services/commonseal.service';
import { AlertComponent } from '../../alert/alert.component';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
@Component({
  selector: 'app-documentundercommonseallist',
  templateUrl: './documentundercommonseallist.component.html',
  styleUrls: ['./documentundercommonseallist.component.css']
})
export class DocumentundercommonseallistComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL: any;
  response: boolean;
  deleteCommonSealId: any;
  dateOfResolution: any;
  dateOfAffixing: any;
  dateOfAffixingTo: any;
  editsealId: any;

  constructor(private commonSeal: CommonsealService, private router: Router, private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }
  ngOnInit() {
    this.environmentSettings = environment;

    this.getRegisterDirectorList();

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Document executed under common seal',
          title: 'Document executed under common seal',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };



  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['commonSeal','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  adjustdirectormasterTable() {
    var directorData = this.masterDirectorList;
    if (directorData.length) {
      this.masterDirectorList = [];
      $("#masterdocumentcommonSealTable").DataTable().destroy();
      this.masterDirectorList = directorData;
      this.dtTriggerRegisterDirector.next();
      setTimeout(() => {
        $("#masterdocumentcommonSealTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#masterdocumentcommonSealTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.commonSeal.getCommonSealList({ isSearch: false }).subscribe(registerList => {
       
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }

  confirmDelete(id) {
    this.deleteCommonSealId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletecommonSealdetail() {
    // this.router.navigate(['/bankparticulars/delete/',ID]);

    this.commonSeal.removecommonSealdetails(this.deleteCommonSealId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#masterdocumentcommonSealTable").DataTable().destroy();
          $('#deleteConfirm').modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getRegisterDirectorList();
      });

  }
  editcommonSeal(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['commonSeal','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['commonSeal/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfAffixing,
      toDate: this.dateOfAffixingTo,
      name: null,
      date1: this.dateOfResolution
    }
    this.commonSeal.generateCommonSealDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.commonSeal.downloadCommonSealFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.commonSeal.downloadCommonSealPdfFile(id, 'Multi');
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "dateOfResolution": this.setDate(this.dateOfResolution),
      'dateOfAffixing': this.setDate(this.dateOfAffixing),
      'dateOfAffixingTo': this.setDate(this.dateOfAffixingTo),
      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#masterdocumentcommonSealTable").DataTable().destroy();
    this.commonSeal.getCommonSealList(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.registerDirectorList = registerList.data;
        this.dtTriggerRegisterDirector.next();
      }
    });
  }
  clearAdvSearch() {
    this.dateOfResolution = undefined;
    this.dateOfAffixing = undefined;
    this.dateOfAffixingTo = undefined;
    $("#masterdocumentcommonSealTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }
}



